import { CustomCheckbox, CustomCheckboxGroup } from 'esocial.web.react.lib/cjs/components/form/Custom/CustomGrouping';
import { Checkbox, FormControl, FormControlLabel, Grid, styled } from '@mui/material';
import { CustomAutocomplete } from 'esocial.web.react.lib/cjs/components/form/Custom/CustomAutocomplete';
import { CustomTextField } from 'esocial.web.react.lib/cjs/components/form/Custom/CustomTextField';
import ListaRegraValidacao from 'esocial.web.react.lib/cjs/components/form/Validation/ListaRegraValidacao';
import RegraCaepf from 'esocial.web.react.lib/cjs/components/form/Validation/RegraCaepf';
import RegraCep from 'esocial.web.react.lib/cjs/components/form/Validation/RegraCep';
import RegraCno from 'esocial.web.react.lib/cjs/components/form/Validation/RegraCno';
import RegraCnpj from 'esocial.web.react.lib/cjs/components/form/Validation/RegraCnpj';
import RegraDiaMesAno from 'esocial.web.react.lib/cjs/components/form/Validation/RegraDiaMesAno';
import RegraExpressaoRegular from 'esocial.web.react.lib/cjs/components/form/Validation/RegraExpressaoRegular';
import RegraHoraMinuto from 'esocial.web.react.lib/cjs/components/form/Validation/RegraHoraMinuto';
import RegraObrigatoriedade from 'esocial.web.react.lib/cjs/components/form/Validation/RegraObrigatoriedade';
import { VepDatePicker } from 'esocial.web.react.lib/cjs/components/form/Vep/VepDatePicker';
import { VepRadioGroup } from 'esocial.web.react.lib/cjs/components/form/Vep/VepRadioGroup';
import { VepSelect } from 'esocial.web.react.lib/cjs/components/form/Vep/VepSelect';
import { VepTextField } from 'esocial.web.react.lib/cjs/components/form/Vep/VepTextField';
import { VepTimePicker } from 'esocial.web.react.lib/cjs/components/form/Vep/VepTimePicker';
import { Display } from 'esocial.web.react.lib/cjs/components/util/Display';
import { Fieldset } from 'esocial.web.react.lib/cjs/components/util/Fieldset';
import { useRequisicaoControlada } from 'esocial.web.react.lib/cjs/hooks/RequisicaoControlada';
import { Mascara, TipoInscricao } from 'esocial.web.react.lib/cjs/utils/enums';
import { isUndefinedOrNull, obterMascaraPorTipoInscricao, obterOpcaoAutocompletePorValorVep, verificarTodosComponentesTocados } from 'esocial.web.react.lib/cjs/utils/geral';
import { Fragment, useEffect, useState } from 'react';

// 26/01/2022
const dataAcidenteValidacaoHoraAcidente = new Date(2022, 0, 26);
const dataImplantacaoVersaoS_1_1 = new Date(2023, 0, 16);

const CnpjAlfanumerico = styled(VepTextField)(() => ({
    '& input': {
        fontFamily: 'monospace'
    }
}));

function Catv_S_01_01_00Consulta(props) {
    // Hook personalizado para requisições ao servidor
    const { get } = useRequisicaoControlada();

    function handleChangeTipoCat(e) {
        // Gerência básica do valor do tipoCat
        // Atribuição do valor padrão ao campo houveObito
        props.setModelo({
            ...props.modelo,
            tipoCat: { ...props.modelo.tipoCat, valor: e.target.value },
            catOrigem: { ...props.modelo.catOrigem, valor: (e.target.value == 2 || e.target.value == 3) ? props.modelo.catOrigem.valor : '' },
            houveObito: { ...props.modelo.houveObito, valor: e.target.value == 2 ? 'N' : (e.target.value == 3 ? 'S' : props.modelo.houveObito.valor) },
            atestadoMedico: {
                ...props.modelo.atestadoMedico, houveAfastamento: { ...props.modelo.atestadoMedico.houveAfastamento, valor: e.target.value == 3 ? 'N' : props.modelo.atestadoMedico.houveAfastamento.valor }
            }
        });
    }

    function handleChangeTipoAcidente(e) {
        // Gerência básica do valor do tipoAcidente
        // Limpeza condicional dos campos horaAcidente e horasTrabalhadasAntesAcidente
        let limparCampoHoraAcidente = true;

        // Com tratamento de exceção pois a data do acidente pode não ser válida
        try {
            if (e.target.value == 1 || (e.target.value == 3 && new Date(props.modelo.dataAcidente.valor) >= dataAcidenteValidacaoHoraAcidente)) {
                limparCampoHoraAcidente = false;
            }
        } catch (e) {
            // Nada a fazer
        }

        props.setModelo({
            ...props.modelo,
            tipoAcidente: { ...props.modelo.tipoAcidente, valor: e.target.value },
            horaAcidente: { ...props.modelo.horaAcidente, valor: !limparCampoHoraAcidente ? props.modelo.horaAcidente.valor : null },
            horasTrabalhadasAntesAcidente: { ...props.modelo.horasTrabalhadasAntesAcidente, valor: !limparCampoHoraAcidente ? props.modelo.horasTrabalhadasAntesAcidente.valor : '' }
        });
    }

    const handleChangeDataAcidente = (date) => {
        let limparCampoHoraAcidente = true;

        // Com tratamento de exceção pois a data do acidente pode não ser válida
        try {
            if (props.modelo.tipoAcidente.valor == 1 || (props.modelo.tipoAcidente.valor == 3 && new Date(date) >= dataAcidenteValidacaoHoraAcidente)) {
                limparCampoHoraAcidente = false;
            }
        } catch (e) {
            // Nada a fazer
        }

        props.setModelo({
            ...props.modelo,
            dataAcidente: { ...props.modelo.dataAcidente, valor: date },
            horaAcidente: { ...props.modelo.horaAcidente, valor: !limparCampoHoraAcidente ? props.modelo.horaAcidente.valor : null },
            horasTrabalhadasAntesAcidente: { ...props.modelo.horasTrabalhadasAntesAcidente, valor: !limparCampoHoraAcidente ? props.modelo.horasTrabalhadasAntesAcidente.valor : '' }
        });
    }

    function handleChangeHouveObito(e) {
        props.setModelo({
            ...props.modelo,
            houveObito: { ...props.modelo.houveObito, valor: e.target.value },
            dataObito: { ...props.modelo.dataObito, valor: e.target.value == 'S' ? props.modelo.dataObito.valor : null },
            atestadoMedico: {
                ...props.modelo.atestadoMedico, houveAfastamento: { ...props.modelo.atestadoMedico.houveAfastamento, valor: e.target.value == 'S' ? 'N' : props.modelo.atestadoMedico.houveAfastamento.valor }
            }
        });
    }

    function handleChangeTipoLocalAcidente(e) {
        props.setModelo({
            ...props.modelo,
            localAcidente: {
                ...props.modelo.localAcidente,
                tipoLocalAcidente: { ...props.modelo.localAcidente.tipoLocalAcidente, valor: e.target.value },
                cep: { ...props.modelo.localAcidente.cep, valor: e.target.value != 2 ? props.modelo.localAcidente.cep.valor : '' },
                municipio: { ...props.modelo.localAcidente.municipio, valor: e.target.value != 2 ? props.modelo.localAcidente.cep.municipio : '' },
                uf: { ...props.modelo.localAcidente.uf, valor: e.target.value != 2 ? props.modelo.localAcidente.uf.valor : '' },
                pais: { ...props.modelo.localAcidente.pais, valor: e.target.value == 2 ? props.modelo.localAcidente.pais.valor : '' },
                codigoPostal: { ...props.modelo.localAcidente.codigoPostal, valor: e.target.value == 2 ? props.modelo.localAcidente.pais.valor : '' }
            }
        });
    }

    async function handleChangeCep(e) {
        const valorCep = e.target.value;
        let endereco;

        if (valorCep && valorCep.length == 9) {
            await get(`util/obterEnderecoPorCep/${valorCep}`, (conteudoResposta) => { endereco = conteudoResposta; });
        }

        if (!isUndefinedOrNull(endereco)) {
            // Buscar a fonte para o campo município
            let fonteDadosAutocompleteMunicipio;
            await get(`util/obterFonteDadosAutocomplete/${props.modelo.localAcidente.municipio.identificadorFonteDados}/${(endereco.uf && endereco.uf.length > 0) ? JSON.stringify({ UF: endereco.uf }) : null}/${endereco.codMunicipioIBGE}`, (conteudoResposta) => { fonteDadosAutocompleteMunicipio = conteudoResposta; }, undefined, { suprimirSobreposicaoMensagens: true });

            props.setModelo({
                ...props.modelo,
                localAcidente: {
                    ...props.modelo.localAcidente,
                    cep: { ...props.modelo.localAcidente.cep, valor: valorCep },
                    tipoLogradouro: { ...props.modelo.localAcidente.tipoLogradouro, valor: endereco.tipoLogradouro },
                    nomeLogradouro: { ...props.modelo.localAcidente.nomeLogradouro, valor: endereco.logradouro },
                    bairro: { ...props.modelo.localAcidente.bairro, valor: endereco.bairro },
                    uf: { ...props.modelo.localAcidente.uf, valor: endereco.uf },
                    municipio: {
                        ...props.modelo.localAcidente.municipio,
                        fonteDadosAutocomplete: !isUndefinedOrNull(fonteDadosAutocompleteMunicipio) ? fonteDadosAutocompleteMunicipio : {},
                        valor: endereco.codMunicipioIBGE
                    },
                    pais: { ...props.modelo.localAcidente.pais, valor: '' }
                }
            });
        }
        else {
            // Simples atribuição do campo CEP
            props.setModelo({
                ...props.modelo,
                localAcidente: {
                    ...props.modelo.localAcidente,
                    cep: { ...props.modelo.localAcidente.cep, valor: valorCep }
                }
            });
        }
    }

    function handleChangeNumeroNaoInformado(e) {
        // Gerência básica do valor do localAcidente.numeroNaoInformado
        // Atribuição condicional do campo localAcidente.numeroLogradouro
        props.setModelo({
            ...props.modelo,
            localAcidente: {
                ...props.modelo.localAcidente,
                numeroNaoInformado: e.target.checked,
                numeroLogradouro: { ...props.modelo.localAcidente.numeroLogradouro, valor: e.target.checked ? 'S/N' : props.modelo.localAcidente.numeroLogradouro.valor }
            }
        });
    }

    function handleChangeTipoInscricaoLocalAcidente(e) {
        // Limpar o número de inscrição em caso de mudança do tipo de inscrição
        props.setModelo({
            ...props.modelo,
            localAcidente: {
                ...props.modelo.localAcidente,
                tipoInscricao: { ...props.modelo.localAcidente.tipoInscricao, valor: e.target.value },
                numeroInscricao: { ...props.modelo.localAcidente.numeroInscricao, valor: '' }
            }
        });
    }

    // Estado de campos ainda não tocados pelo usuário e formulário ainda não submetido (usado no mecanismo de validações)
    const objetoComponentesTocados = {};

    objetoComponentesTocados['tipoCat'] = false;
    objetoComponentesTocados['catOrigem'] = false;
    objetoComponentesTocados['tipoAcidente'] = false;
    objetoComponentesTocados['dataAcidente'] = false;
    objetoComponentesTocados['horaAcidente'] = false;
    objetoComponentesTocados['horasTrabalhadasAntesAcidente'] = false;
    objetoComponentesTocados['dataUltimoDiaTrabalhado'] = false;
    objetoComponentesTocados['houveAfastamentoCat'] = false;
    objetoComponentesTocados['houveObito'] = false;
    objetoComponentesTocados['dataObito'] = false;
    objetoComponentesTocados['houveComunicacaoAutoridadePolicial'] = false;
    objetoComponentesTocados['situacaoGeradoraAcidente'] = false;
    objetoComponentesTocados['catEmitidaPor'] = false;
    objetoComponentesTocados['localAcidente.tipoLocalAcidente'] = false;
    objetoComponentesTocados['localAcidente.cep'] = false;
    objetoComponentesTocados['localAcidente.tipoLogradouro'] = false;
    objetoComponentesTocados['localAcidente.nomeLogradouro'] = false;
    objetoComponentesTocados['localAcidente.numeroLogradouro'] = false;
    objetoComponentesTocados['localAcidente.uf'] = false;
    objetoComponentesTocados['localAcidente.municipio'] = false;
    objetoComponentesTocados['localAcidente.pais'] = false;
    objetoComponentesTocados['localAcidente.codigoPostal'] = false;
    objetoComponentesTocados['localAcidente.tipoInscricao'] = false;
    objetoComponentesTocados['localAcidente.numeroInscricao'] = false;
    objetoComponentesTocados['parteAtingida'] = false;
    objetoComponentesTocados['lateralidade'] = false;
    objetoComponentesTocados['agenteCausador'] = false;
    objetoComponentesTocados['atestadoMedico.dataAtendimento'] = false;
    objetoComponentesTocados['atestadoMedico.horaAtendimento'] = false;
    objetoComponentesTocados['atestadoMedico.houveInternacao'] = false;
    objetoComponentesTocados['atestadoMedico.duracaoEstimadaTratamentoEmDias'] = false;
    objetoComponentesTocados['atestadoMedico.houveAfastamento'] = false;
    objetoComponentesTocados['atestadoMedico.naturezaLesao'] = false;
    objetoComponentesTocados['atestadoMedico.cid'] = false;
    objetoComponentesTocados['atestadoMedico.nomeEmitente'] = false;
    objetoComponentesTocados['atestadoMedico.orgaoClasse'] = false;
    objetoComponentesTocados['atestadoMedico.numeroInscricaoOrgaoClasse'] = false;
    objetoComponentesTocados['atestadoMedico.ufOrgaoClasse'] = false;

    const [componenteTocadoFormulario, setComponenteTocadoFormulario] = useState(objetoComponentesTocados);

    // Construção das regras de validação para os campos do formulário
    const [regraValidacaoFormulario, setRegraValidacaoFormulario] = useState({});

    useEffect(() => {
        const objetoRegrasValidacao = {};

        if (props.modelo != null) {
            objetoRegrasValidacao['tipoCat'] = new RegraObrigatoriedade(props.modelo.tipoCat.valor, componenteTocadoFormulario['tipoCat']);
            objetoRegrasValidacao['catOrigem'] = new RegraObrigatoriedade(props.modelo.catOrigem.valor, componenteTocadoFormulario['catOrigem'] && (props.modelo.tipoCat.valor == 2 || props.modelo.tipoCat.valor == 3));
            objetoRegrasValidacao['tipoAcidente'] = new RegraObrigatoriedade(props.modelo.tipoAcidente.valor, componenteTocadoFormulario['tipoAcidente']);
            objetoRegrasValidacao['dataAcidente'] = new ListaRegraValidacao([new RegraObrigatoriedade(props.modelo.dataAcidente.valor), new RegraDiaMesAno(props.modelo.dataAcidente.valor)], componenteTocadoFormulario['dataAcidente']);
            objetoRegrasValidacao['horaAcidente'] = new ListaRegraValidacao([new RegraObrigatoriedade(props.modelo.horaAcidente.valor, (props.modelo.tipoAcidente.valor == 1 || (props.modelo.tipoAcidente.valor == 3 && !objetoRegrasValidacao['dataAcidente'].existeErro() && new Date(props.modelo.dataAcidente.valor) >= dataAcidenteValidacaoHoraAcidente))), new RegraHoraMinuto(props.modelo.horaAcidente.valor)], componenteTocadoFormulario['horaAcidente']);
            objetoRegrasValidacao['horasTrabalhadasAntesAcidente'] = new ListaRegraValidacao([new RegraObrigatoriedade(props.modelo.horasTrabalhadasAntesAcidente.valor, (props.modelo.tipoAcidente.valor == 1 || (props.modelo.tipoAcidente.valor == 3 && !objetoRegrasValidacao['dataAcidente'].existeErro() && new Date(props.modelo.dataAcidente.valor) >= dataAcidenteValidacaoHoraAcidente))), new RegraExpressaoRegular(props.modelo.horasTrabalhadasAntesAcidente.valor, '([0-9]{2})([:]?)([012345][0-9])')], componenteTocadoFormulario['horasTrabalhadasAntesAcidente']);
            objetoRegrasValidacao['dataUltimoDiaTrabalhado'] = new ListaRegraValidacao([new RegraObrigatoriedade(props.modelo.dataUltimoDiaTrabalhado.valor, (!objetoRegrasValidacao['dataAcidente'].existeErro() && new Date(props.modelo.dataAcidente.valor) >= dataImplantacaoVersaoS_1_1)), new RegraDiaMesAno(props.modelo.dataUltimoDiaTrabalhado.valor)], componenteTocadoFormulario['dataUltimoDiaTrabalhado']);
            objetoRegrasValidacao['houveAfastamentoCat'] = new ListaRegraValidacao([new RegraObrigatoriedade(props.modelo.houveAfastamentoCat.valor, (!objetoRegrasValidacao['dataAcidente'].existeErro() && new Date(props.modelo.dataAcidente.valor) >= dataImplantacaoVersaoS_1_1))], componenteTocadoFormulario['houveAfastamentoCat']);
            objetoRegrasValidacao['houveObito'] = new RegraObrigatoriedade(props.modelo.houveObito.valor, componenteTocadoFormulario['houveObito']);
            objetoRegrasValidacao['dataObito'] = new ListaRegraValidacao([new RegraObrigatoriedade(props.modelo.dataObito.valor), new RegraDiaMesAno(props.modelo.dataObito.valor)], componenteTocadoFormulario['dataObito'] && props.modelo.houveObito.valor == 'S');
            objetoRegrasValidacao['houveComunicacaoAutoridadePolicial'] = new RegraObrigatoriedade(props.modelo.houveComunicacaoAutoridadePolicial.valor, componenteTocadoFormulario['houveComunicacaoAutoridadePolicial']);
            objetoRegrasValidacao['situacaoGeradoraAcidente'] = new RegraObrigatoriedade(props.modelo.situacaoGeradoraAcidente.valor, componenteTocadoFormulario['situacaoGeradoraAcidente']);
            objetoRegrasValidacao['catEmitidaPor'] = new RegraObrigatoriedade(props.modelo.catEmitidaPor.valor, componenteTocadoFormulario['catEmitidaPor']);
            objetoRegrasValidacao['localAcidente.tipoLocalAcidente'] = new RegraObrigatoriedade(props.modelo.localAcidente.tipoLocalAcidente.valor, componenteTocadoFormulario['localAcidente.tipoLocalAcidente']);
            objetoRegrasValidacao['localAcidente.cep'] = new ListaRegraValidacao([new RegraObrigatoriedade(props.modelo.localAcidente.cep.valor, props.modelo.localAcidente.tipoLocalAcidente.valor == 1 || props.modelo.localAcidente.tipoLocalAcidente.valor == 3 || props.modelo.localAcidente.tipoLocalAcidente.valor == 5), new RegraCep(props.modelo.localAcidente.cep.valor)], componenteTocadoFormulario['localAcidente.cep'] && props.modelo.localAcidente.tipoLocalAcidente.valor != 2);
            objetoRegrasValidacao['localAcidente.tipoLogradouro'] = new RegraObrigatoriedade(props.modelo.localAcidente.tipoLogradouro.valor, componenteTocadoFormulario['localAcidente.tipoLogradouro']);
            objetoRegrasValidacao['localAcidente.nomeLogradouro'] = new RegraObrigatoriedade(props.modelo.localAcidente.nomeLogradouro.valor, componenteTocadoFormulario['localAcidente.nomeLogradouro']);
            objetoRegrasValidacao['localAcidente.numeroLogradouro'] = new RegraObrigatoriedade(props.modelo.localAcidente.numeroLogradouro.valor, componenteTocadoFormulario['localAcidente.numeroLogradouro'] && !props.modelo.localAcidente.numeroNaoInformado);
            objetoRegrasValidacao['localAcidente.uf'] = new RegraObrigatoriedade(props.modelo.localAcidente.uf.valor, componenteTocadoFormulario['localAcidente.uf'] && props.modelo.localAcidente.tipoLocalAcidente.valor != 2 && (props.modelo.localAcidente.tipoLocalAcidente.valor == 1 || props.modelo.localAcidente.tipoLocalAcidente.valor == 3 || props.modelo.localAcidente.tipoLocalAcidente.valor == 4 || props.modelo.localAcidente.tipoLocalAcidente.valor == 5));
            objetoRegrasValidacao['localAcidente.municipio'] = new RegraObrigatoriedade(props.modelo.localAcidente.municipio.valor, componenteTocadoFormulario['localAcidente.municipio'] && props.modelo.localAcidente.tipoLocalAcidente.valor != 2 && (props.modelo.localAcidente.tipoLocalAcidente.valor == 1 || props.modelo.localAcidente.tipoLocalAcidente.valor == 3 || props.modelo.localAcidente.tipoLocalAcidente.valor == 4 || props.modelo.localAcidente.tipoLocalAcidente.valor == 5));
            objetoRegrasValidacao['localAcidente.pais'] = new RegraObrigatoriedade(props.modelo.localAcidente.pais.valor, componenteTocadoFormulario['localAcidente.pais'] && props.modelo.localAcidente.tipoLocalAcidente.valor == 2);
            objetoRegrasValidacao['localAcidente.codigoPostal'] = new RegraObrigatoriedade(props.modelo.localAcidente.codigoPostal.valor, componenteTocadoFormulario['localAcidente.codigoPostal'] && props.modelo.localAcidente.tipoLocalAcidente.valor == 2);
            objetoRegrasValidacao['localAcidente.tipoInscricao'] = new RegraObrigatoriedade(props.modelo.localAcidente.tipoInscricao.valor, componenteTocadoFormulario['localAcidente.tipoInscricao']);
            objetoRegrasValidacao['localAcidente.numeroInscricao'] = new ListaRegraValidacao([new RegraObrigatoriedade(props.modelo.localAcidente.numeroInscricao.valor), new RegraCnpj(props.modelo.localAcidente.numeroInscricao.valor, parseInt(props.modelo.localAcidente.tipoInscricao.valor) === TipoInscricao.CNPJ), new RegraCaepf(props.modelo.localAcidente.numeroInscricao.valor, parseInt(props.modelo.localAcidente.tipoInscricao.valor) === TipoInscricao.CAEPF), new RegraCno(props.modelo.localAcidente.numeroInscricao.valor, parseInt(props.modelo.localAcidente.tipoInscricao.valor) === TipoInscricao.CNO)], componenteTocadoFormulario['localAcidente.numeroInscricao']);
            objetoRegrasValidacao['parteAtingida'] = new RegraObrigatoriedade(props.modelo.parteAtingida.valor, componenteTocadoFormulario['parteAtingida']);
            objetoRegrasValidacao['lateralidade'] = new RegraObrigatoriedade(props.modelo.lateralidade.valor, componenteTocadoFormulario['lateralidade']);
            objetoRegrasValidacao['agenteCausador'] = new RegraObrigatoriedade(props.modelo.agenteCausador.valor, componenteTocadoFormulario['agenteCausador']);
            objetoRegrasValidacao['atestadoMedico.dataAtendimento'] = new ListaRegraValidacao([new RegraObrigatoriedade(props.modelo.atestadoMedico.dataAtendimento.valor), new RegraDiaMesAno(props.modelo.atestadoMedico.dataAtendimento.valor)], componenteTocadoFormulario['atestadoMedico.dataAtendimento']);
            objetoRegrasValidacao['atestadoMedico.horaAtendimento'] = new ListaRegraValidacao([new RegraObrigatoriedade(props.modelo.atestadoMedico.horaAtendimento.valor), new RegraHoraMinuto(props.modelo.atestadoMedico.horaAtendimento.valor)], componenteTocadoFormulario['atestadoMedico.horaAtendimento']);
            objetoRegrasValidacao['atestadoMedico.houveInternacao'] = new RegraObrigatoriedade(props.modelo.atestadoMedico.houveInternacao.valor, componenteTocadoFormulario['atestadoMedico.houveInternacao']);
            objetoRegrasValidacao['atestadoMedico.duracaoEstimadaTratamentoEmDias'] = new RegraObrigatoriedade(props.modelo.atestadoMedico.duracaoEstimadaTratamentoEmDias.valor, componenteTocadoFormulario['atestadoMedico.duracaoEstimadaTratamentoEmDias']);
            objetoRegrasValidacao['atestadoMedico.houveAfastamento'] = new RegraObrigatoriedade(props.modelo.atestadoMedico.houveAfastamento.valor, componenteTocadoFormulario['atestadoMedico.houveAfastamento'] && props.modelo.houveObito.valor == 'N');
            objetoRegrasValidacao['atestadoMedico.naturezaLesao'] = new RegraObrigatoriedade(props.modelo.atestadoMedico.naturezaLesao.valor, componenteTocadoFormulario['atestadoMedico.naturezaLesao']);
            objetoRegrasValidacao['atestadoMedico.cid'] = new RegraObrigatoriedade(props.modelo.atestadoMedico.cid.valor, componenteTocadoFormulario['atestadoMedico.cid']);
            objetoRegrasValidacao['atestadoMedico.nomeEmitente'] = new RegraObrigatoriedade(props.modelo.atestadoMedico.nomeEmitente.valor, componenteTocadoFormulario['atestadoMedico.nomeEmitente']);
            objetoRegrasValidacao['atestadoMedico.orgaoClasse'] = new RegraObrigatoriedade(props.modelo.atestadoMedico.orgaoClasse.valor, componenteTocadoFormulario['atestadoMedico.orgaoClasse']);
            objetoRegrasValidacao['atestadoMedico.numeroInscricaoOrgaoClasse'] = new RegraObrigatoriedade(props.modelo.atestadoMedico.numeroInscricaoOrgaoClasse.valor, componenteTocadoFormulario['atestadoMedico.numeroInscricaoOrgaoClasse']);
            objetoRegrasValidacao['atestadoMedico.ufOrgaoClasse'] = new RegraObrigatoriedade(props.modelo.atestadoMedico.ufOrgaoClasse.valor, componenteTocadoFormulario['atestadoMedico.ufOrgaoClasse'] && (props.modelo.atestadoMedico.orgaoClasse.valor == 1 || props.modelo.atestadoMedico.orgaoClasse.valor == 2));
            objetoRegrasValidacao.todosComponentesTocados = verificarTodosComponentesTocados(componenteTocadoFormulario);
        }

        setRegraValidacaoFormulario(objetoRegrasValidacao);
    }, [props.modelo, componenteTocadoFormulario]);

    return (
        (props.modelo !== null && Object.values(regraValidacaoFormulario).length > 0) &&
        <Fragment>
            <Fieldset legend="Identificação do Trabalhador" spacing={4}>
                <VepTextField
                    accessor="cpf"
                    label="CPF"
                    model={props.modelo}
                    xs={12} md={3}
                    readOnly
                    maskPattern={Mascara.CPF}
                />

                <CustomTextField
                    xs={12} md={6}
                    label="Nome"
                    value={props.modelo.nome}
                    readOnly />

                <VepTextField
                    accessor="matricula"
                    model={props.modelo}
                    xs={12} md={3}
                    readOnly
                />
            </Fieldset>

            <Fieldset legend="Comunicação de Acidente de Trabalho" spacing={4}>
                <VepSelect
                    accessor="tipoCat"
                    model={props.modelo}
                    value={props.modelo.tipoCat.valor}
                    onChange={(e) => handleChangeTipoCat(e)}
                    setModel={props.setModelo}
                    xs={12} md={3}
                    readOnly={props.visualizacao}
                    {...regraValidacaoFormulario['tipoCat'].obterPropriedadesValidacao()}
                    onBlur={() => setComponenteTocadoFormulario({ ...componenteTocadoFormulario, 'tipoCat': true })}
                />

                <Display show={props.modelo.tipoCat.valor == 2 || props.modelo.tipoCat.valor == 3}>
                    <VepSelect
                        accessor="catOrigem"
                        label="CAT de Origem"
                        required
                        model={props.modelo}
                        setModel={props.setModelo}
                        xs={12} md={4}
                        readOnly={props.visualizacao}
                        {...regraValidacaoFormulario['catOrigem'].obterPropriedadesValidacao()}
                        onBlur={() => setComponenteTocadoFormulario({ ...componenteTocadoFormulario, 'catOrigem': true })}
                    />
                </Display>

                <VepSelect
                    accessor="tipoAcidente"
                    label="Tipo do Acidente"
                    model={props.modelo}
                    value={props.modelo.tipoAcidente.valor}
                    onChange={(e) => handleChangeTipoAcidente(e)}
                    xs={12} md={3}
                    readOnly={props.visualizacao}
                    {...regraValidacaoFormulario['tipoAcidente'].obterPropriedadesValidacao()}
                    onBlur={() => setComponenteTocadoFormulario({ ...componenteTocadoFormulario, 'tipoAcidente': true })}
                />

                <VepDatePicker
                    accessor="dataAcidente"
                    model={props.modelo}
                    value={props.modelo.dataAcidente.valor}
                    onChange={date => handleChangeDataAcidente(date)}
                    xs={12} md={3}
                    readOnly={props.visualizacao}
                    {...regraValidacaoFormulario['dataAcidente'].obterPropriedadesValidacao()}
                    onBlur={() => setComponenteTocadoFormulario({ ...componenteTocadoFormulario, 'dataAcidente': true })}
                />

                <Display show={props.modelo.tipoAcidente.valor == 1 || (props.modelo.tipoAcidente.valor == 3 && !regraValidacaoFormulario['dataAcidente'].existeErro() && new Date(props.modelo.dataAcidente.valor) >= dataAcidenteValidacaoHoraAcidente)}>
                    <VepTimePicker
                        accessor="horaAcidente"
                        label="Hora do Acidente"
                        required
                        readOnly={props.visualizacao}
                        model={props.modelo}
                        setModel={props.setModelo}
                        xs={12} md={3}
                        {...regraValidacaoFormulario['horaAcidente'].obterPropriedadesValidacao()}
                        onBlur={() => setComponenteTocadoFormulario({ ...componenteTocadoFormulario, 'horaAcidente': true })}
                    />
                </Display>

                <VepTextField
                    accessor="horasTrabalhadasAntesAcidente"
                    label=" Quantidade de horas trabalhadas antes do acidente"
                    required={props.modelo.tipoAcidente.valor == 1 || (props.modelo.tipoAcidente.valor == 3 && !regraValidacaoFormulario['dataAcidente'].existeErro() && new Date(props.modelo.dataAcidente.valor) >= dataAcidenteValidacaoHoraAcidente)}
                    readOnly={props.visualizacao}
                    disabled={!(props.modelo.tipoAcidente.valor == 1 || (props.modelo.tipoAcidente.valor == 3 && !regraValidacaoFormulario['dataAcidente'].existeErro() && new Date(props.modelo.dataAcidente.valor) >= dataAcidenteValidacaoHoraAcidente))}
                    maskNumber={false}
                    model={props.modelo}
                    setModel={props.setModelo}
                    xs={12} md={5}
                    maskPattern={Mascara.HHmm}
                    placeholder="hh:mm"
                    {...regraValidacaoFormulario['horasTrabalhadasAntesAcidente'].obterPropriedadesValidacao()}
                    onBlur={() => setComponenteTocadoFormulario({ ...componenteTocadoFormulario, 'horasTrabalhadasAntesAcidente': true })}
                />

                <VepDatePicker
                    accessor="dataUltimoDiaTrabalhado"
                    required={new Date(props.modelo.dataAcidente.valor) >= dataImplantacaoVersaoS_1_1}
                    model={props.modelo}
                    setModel={props.setModelo}
                    xs={12} md={3}
                    readOnly={props.visualizacao}
                    {...regraValidacaoFormulario['dataUltimoDiaTrabalhado'].obterPropriedadesValidacao()}
                    onBlur={() => setComponenteTocadoFormulario({ ...componenteTocadoFormulario, 'dataUltimoDiaTrabalhado': true })}
                />

                <VepRadioGroup
                    accessor="houveAfastamentoCat"
                    label="Houve afastamento?"
                    required={new Date(props.modelo.dataAcidente.valor) >= dataImplantacaoVersaoS_1_1}
                    model={props.modelo}
                    setModel={props.setModelo}
                    xs={12} md={4}
                    readOnly={props.visualizacao}
                    {...regraValidacaoFormulario['houveAfastamentoCat'].obterPropriedadesValidacao()}
                    onBlur={() => setComponenteTocadoFormulario({ ...componenteTocadoFormulario, 'houveAfastamentoCat': true })}
                />

                <VepRadioGroup
                    accessor="houveObito"
                    label="Houve óbito?"
                    model={props.modelo}
                    value={props.modelo.houveObito.valor}
                    onChange={(e) => handleChangeHouveObito(e)}
                    xs={12} md={2}
                    readOnly={props.visualizacao}
                    disabled={props.modelo.tipoCat.valor == 2 || props.modelo.tipoCat.valor == 3}
                    {...regraValidacaoFormulario['houveObito'].obterPropriedadesValidacao()}
                    onBlur={() => setComponenteTocadoFormulario({ ...componenteTocadoFormulario, 'houveObito': true })}
                />

                <Display show={props.modelo.houveObito.valor == 'S'}>
                    <VepDatePicker
                        accessor="dataObito"
                        required
                        model={props.modelo}
                        setModel={props.setModelo}
                        xs={12} md={3}
                        readOnly={props.visualizacao}
                        {...regraValidacaoFormulario['dataObito'].obterPropriedadesValidacao()}
                        onBlur={() => setComponenteTocadoFormulario({ ...componenteTocadoFormulario, 'dataObito': true })}
                    />
                </Display>

                <VepRadioGroup
                    accessor="houveComunicacaoAutoridadePolicial"
                    label=" Houve comunicação à autoridade policial?"
                    model={props.modelo}
                    setModel={props.setModelo}
                    xs={12} md={4}
                    readOnly={props.visualizacao}
                    {...regraValidacaoFormulario['houveComunicacaoAutoridadePolicial'].obterPropriedadesValidacao()}
                    onBlur={() => setComponenteTocadoFormulario({ ...componenteTocadoFormulario, 'houveComunicacaoAutoridadePolicial': true })}
                />

                <CustomAutocomplete
                    md={8}
                    options={props.modelo.situacaoGeradoraAcidente.fonteDadosAutocomplete}
                    getOptionLabel={(option) => option.rotulo}
                    value={obterOpcaoAutocompletePorValorVep(props.modelo.situacaoGeradoraAcidente.fonteDadosAutocomplete, props.modelo.situacaoGeradoraAcidente.valor)}
                    onChange={(event, newValue) => {
                        props.setModelo({ ...props.modelo, situacaoGeradoraAcidente: { ...props.modelo.situacaoGeradoraAcidente, valor: newValue != null ? newValue.valor : '' } });
                    }}
                    readOnly={props.visualizacao}
                    inputProps={{
                        label: 'Situação Geradora do Acidente',
                        title: props.modelo.situacaoGeradoraAcidente.descricao,
                        required: true,
                        ...regraValidacaoFormulario['situacaoGeradoraAcidente'].obterPropriedadesValidacao(),
                        onBlur: () => setComponenteTocadoFormulario({ ...componenteTocadoFormulario, 'situacaoGeradoraAcidente': true })
                    }}
                />

                <VepSelect
                    accessor="catEmitidaPor"
                    label="CAT emitida por"
                    model={props.modelo}
                    setModel={props.setModelo}
                    xs={12} md={4}
                    readOnly={props.visualizacao}
                    {...regraValidacaoFormulario['catEmitidaPor'].obterPropriedadesValidacao()}
                    onBlur={() => setComponenteTocadoFormulario({ ...componenteTocadoFormulario, 'catEmitidaPor': true })}
                />

                <VepTextField
                    accessor="observacao"
                    model={props.modelo}
                    setModel={props.setModelo}
                    xs={12} md={12}
                    multiline
                    rows={4}
                    readOnly={props.visualizacao}
                />
            </Fieldset>

            <Fieldset legend="Local do Acidente de Trabalho" spacing={4}>
                <VepSelect
                    accessor="localAcidente.tipoLocalAcidente"
                    label="Tipo do Local do Acidente"
                    model={props.modelo}
                    value={props.modelo.localAcidente.tipoLocalAcidente.valor}
                    onChange={(e) => handleChangeTipoLocalAcidente(e)}
                    xs={12} md={6}
                    readOnly={props.visualizacao}
                    {...regraValidacaoFormulario['localAcidente.tipoLocalAcidente'].obterPropriedadesValidacao()}
                    onBlur={() => setComponenteTocadoFormulario({ ...componenteTocadoFormulario, 'localAcidente.tipoLocalAcidente': true })}
                />

                <Display show={props.modelo.localAcidente.tipoLocalAcidente.valor != 2}>
                    <VepTextField
                        accessor="localAcidente.cep"
                        required={props.modelo.localAcidente.tipoLocalAcidente.valor == 1 || props.modelo.localAcidente.tipoLocalAcidente.valor == 3 || props.modelo.localAcidente.tipoLocalAcidente.valor == 5}
                        readOnly={props.visualizacao}
                        disabled={props.modelo.localAcidente.tipoLocalAcidente.valor == 2}
                        maxLength={9}
                        model={props.modelo}
                        value={props.modelo.localAcidente.cep.valor}
                        onChange={(e) => handleChangeCep(e)}
                        xs={12} md={2}
                        maskPattern={Mascara.CEP}
                        {...regraValidacaoFormulario['localAcidente.cep'].obterPropriedadesValidacao()}
                        onBlur={() => setComponenteTocadoFormulario({ ...componenteTocadoFormulario, 'localAcidente.cep': true })}
                    />
                </Display>

                <VepTextField
                    accessor="localAcidente.tipoLogradouro"
                    label="Tipo do Logradouro"
                    model={props.modelo}
                    setModel={props.setModelo}
                    xs={12} md={4}
                    required
                    readOnly={props.visualizacao}
                    {...regraValidacaoFormulario['localAcidente.tipoLogradouro'].obterPropriedadesValidacao()}
                    onBlur={() => setComponenteTocadoFormulario({ ...componenteTocadoFormulario, 'localAcidente.tipoLogradouro': true })}
                />

                <VepTextField
                    accessor="localAcidente.nomeLogradouro"
                    label="Nome do Logradouro"
                    model={props.modelo}
                    setModel={props.setModelo}
                    xs={12} md={7}
                    readOnly={props.visualizacao}
                    {...regraValidacaoFormulario['localAcidente.nomeLogradouro'].obterPropriedadesValidacao()}
                    onBlur={() => setComponenteTocadoFormulario({ ...componenteTocadoFormulario, 'localAcidente.nomeLogradouro': true })}
                />

                <VepTextField
                    accessor="localAcidente.numeroLogradouro"
                    label="Número do Logradouro"
                    required={!props.modelo.localAcidente.numeroNaoInformado}
                    readOnly={props.visualizacao}
                    disabled={props.modelo.localAcidente.numeroNaoInformado}
                    model={props.modelo}
                    setModel={props.setModelo}
                    xs={12} md={3}
                    {...regraValidacaoFormulario['localAcidente.numeroLogradouro'].obterPropriedadesValidacao()}
                    onBlur={() => setComponenteTocadoFormulario({ ...componenteTocadoFormulario, 'localAcidente.numeroLogradouro': true })}
                />

                <Grid item style={{ flexBasis: '16.666667%' }}>
                    <CustomCheckboxGroup md={12} readOnly={props.visualizacao}>
                        <CustomCheckbox
                            label="Número não informado"
                            checked={props.modelo.localAcidente.numeroNaoInformado}
                            onChange={(e) => handleChangeNumeroNaoInformado(e)}
                            readOnly={props.visualizacao}
                        />
                    </CustomCheckboxGroup>
                </Grid>

                <VepTextField
                    accessor="localAcidente.complemento"
                    label="Complemento"
                    model={props.modelo}
                    setModel={props.setModelo}
                    xs={12} md={6}
                    readOnly={props.visualizacao}
                />

                <VepTextField
                    accessor="localAcidente.bairro"
                    label="Bairro"
                    model={props.modelo}
                    setModel={props.setModelo}
                    xs={12} md={6}
                    readOnly={props.visualizacao}
                />

                <Display show={props.modelo.localAcidente.tipoLocalAcidente.valor != 2}>
                    <VepSelect
                        accessor="localAcidente.uf"
                        required={props.modelo.localAcidente.tipoLocalAcidente.valor == 1 || props.modelo.localAcidente.tipoLocalAcidente.valor == 3 || props.modelo.localAcidente.tipoLocalAcidente.valor == 4 || props.modelo.localAcidente.tipoLocalAcidente.valor == 5}
                        readOnly={props.visualizacao}
                        model={props.modelo}
                        setModel={props.setModelo}
                        xs={12} md={2}
                        {...regraValidacaoFormulario['localAcidente.uf'].obterPropriedadesValidacao()}
                        onBlur={() => setComponenteTocadoFormulario({ ...componenteTocadoFormulario, 'localAcidente.uf': true })}
                    />
                </Display>

                <Display show={props.modelo.localAcidente.tipoLocalAcidente.valor != 2}>
                    <CustomAutocomplete
                        md={6}
                        queryUrl={`util/obterFonteDadosAutocomplete/${props.modelo.localAcidente.municipio.identificadorFonteDados}/${(props.modelo.localAcidente.uf.valor && props.modelo.localAcidente.uf.valor.length > 0) ? JSON.stringify({ UF: props.modelo.localAcidente.uf.valor }) : null}`}
                        queryMinLength={3}
                        getOptionLabel={(option) => option.rotulo}
                        value={obterOpcaoAutocompletePorValorVep(props.modelo.localAcidente.municipio.fonteDadosAutocomplete, props.modelo.localAcidente.municipio.valor)}
                        onChange={(event, newValue) => {
                            props.setModelo({ ...props.modelo, localAcidente: { ...props.modelo.localAcidente, municipio: { ...props.modelo.localAcidente.municipio, valor: !isUndefinedOrNull(newValue) ? newValue.valor : '', fonteDadosAutocomplete: !isUndefinedOrNull(newValue) ? [newValue] : [] } } });
                        }}
                        readOnly={props.visualizacao}
                        inputProps={{
                            label: 'Município',
                            title: props.modelo.localAcidente.municipio.descricao,
                            required: props.modelo.localAcidente.tipoLocalAcidente.valor == 1 || props.modelo.localAcidente.tipoLocalAcidente.valor == 3 || props.modelo.localAcidente.tipoLocalAcidente.valor == 4 || props.modelo.localAcidente.tipoLocalAcidente.valor == 5,
                            ...regraValidacaoFormulario['localAcidente.municipio'].obterPropriedadesValidacao(),
                            onBlur: () => setComponenteTocadoFormulario({ ...componenteTocadoFormulario, 'localAcidente.municipio': true })
                        }}
                    />
                </Display>

                {/*País*/}
                <Display show={props.modelo.localAcidente.tipoLocalAcidente.valor != 2}>
                    <CustomTextField
                        xs={12} md={4}
                        label="País"
                        value={props.modelo.localAcidente.pais.fonteDadosAutocomplete.filter(x => x.valor === '105')[0].rotulo}
                        readOnly />
                </Display>
                <Display show={props.modelo.localAcidente.tipoLocalAcidente.valor == 2}>
                    <CustomAutocomplete
                        md={4}
                        options={props.modelo.localAcidente.pais.fonteDadosAutocomplete.filter(x => x.valor !== '105')}
                        getOptionLabel={(option) => option.rotulo}
                        value={obterOpcaoAutocompletePorValorVep(props.modelo.localAcidente.pais.fonteDadosAutocomplete, props.modelo.localAcidente.pais.valor)}
                        onChange={(event, newValue) => {
                            props.setModelo({ ...props.modelo, localAcidente: { ...props.modelo.localAcidente, pais: { ...props.modelo.localAcidente.pais, valor: newValue != null ? newValue.valor : '' } } });
                        }}
                        readOnly={props.visualizacao}
                        inputProps={{
                            label: 'País',
                            title: props.modelo.localAcidente.pais.descricao,
                            required: true,
                            ...regraValidacaoFormulario['localAcidente.pais'].obterPropriedadesValidacao(),
                            onBlur: () => setComponenteTocadoFormulario({ ...componenteTocadoFormulario, 'localAcidente.pais': true })
                        }}
                    />
                </Display>

                <Display show={props.modelo.localAcidente.tipoLocalAcidente.valor == 2}>
                    <VepTextField
                        accessor="localAcidente.codigoPostal"
                        label="Código Postal"
                        required
                        model={props.modelo}
                        setModel={props.setModelo}
                        xs={12} md={2}
                        readOnly={props.visualizacao}
                        {...regraValidacaoFormulario['localAcidente.codigoPostal'].obterPropriedadesValidacao()}
                        onBlur={() => setComponenteTocadoFormulario({ ...componenteTocadoFormulario, 'localAcidente.codigoPostal': true })}
                    />
                </Display>

                <VepTextField
                    accessor="localAcidente.especificacaoLocalAcidente"
                    label="Especificação do local do acidente (pátio, rampa de acesso, posto de trabalho, etc.)"
                    model={props.modelo}
                    setModel={props.setModelo}
                    xs={12} md={12}
                    multiline
                    rows={4}
                    readOnly={props.visualizacao}
                />
            </Fieldset>

            <Display show={(props.modelo.tipoInscricaoEmpregador == 1 && (props.modelo.localAcidente.tipoLocalAcidente.valor == 1 || props.modelo.localAcidente.tipoLocalAcidente.valor == 3)) || props.modelo.codCategoria.startsWith('2')}>
                <Fieldset legend="Identificação do local onde ocorreu o acidente" spacing={4}>
                    <VepSelect
                        accessor="localAcidente.tipoInscricao"
                        label="Tipo de inscrição do local onde ocorreu o acidente ou a doença ocupacional"
                        model={props.modelo}
                        value={props.modelo.localAcidente.tipoInscricao.valor}
                        onChange={(e) => handleChangeTipoInscricaoLocalAcidente(e)}
                        xs={12} md={7}
                        readOnly={props.visualizacao}
                        {...regraValidacaoFormulario['localAcidente.tipoInscricao'].obterPropriedadesValidacao()}
                        onBlur={() => setComponenteTocadoFormulario({ ...componenteTocadoFormulario, 'localAcidente.tipoInscricao': true })}
                    />

                    <CnpjAlfanumerico
                        accessor="localAcidente.numeroInscricao"
                        label="Número de Inscrição"
                        model={props.modelo}
                        setModel={props.setModelo}
                        xs={12} md={3}
                        maskPattern={obterMascaraPorTipoInscricao(props.modelo.localAcidente.tipoInscricao.valor)}
                        readOnly={props.visualizacao}
                        {...regraValidacaoFormulario['localAcidente.numeroInscricao'].obterPropriedadesValidacao()}
                        onBlur={() => setComponenteTocadoFormulario({ ...componenteTocadoFormulario, 'localAcidente.numeroInscricao': true })}
                    />
                </Fieldset>
            </Display>

            <Fieldset legend="Parte atingida pelo acidente de trabalho" spacing={4}>
                <CustomAutocomplete
                    md={9}
                    options={props.modelo.parteAtingida.fonteDadosAutocomplete}
                    getOptionLabel={(option) => option.rotulo}
                    value={obterOpcaoAutocompletePorValorVep(props.modelo.parteAtingida.fonteDadosAutocomplete, props.modelo.parteAtingida.valor)}
                    onChange={(event, newValue) => {
                        props.setModelo({ ...props.modelo, parteAtingida: { ...props.modelo.parteAtingida, valor: newValue != null ? newValue.valor : '' } });
                    }}
                    readOnly={props.visualizacao}
                    inputProps={{
                        label: 'Parte Atingida',
                        title: props.modelo.parteAtingida.descricao,
                        required: true,
                        ...regraValidacaoFormulario['parteAtingida'].obterPropriedadesValidacao(),
                        onBlur: () => setComponenteTocadoFormulario({ ...componenteTocadoFormulario, 'parteAtingida': true })
                    }}
                />

                <VepSelect
                    accessor="lateralidade"
                    model={props.modelo}
                    setModel={props.setModelo}
                    xs={12} md={3}
                    readOnly={props.visualizacao}
                    {...regraValidacaoFormulario['lateralidade'].obterPropriedadesValidacao()}
                    onBlur={() => setComponenteTocadoFormulario({ ...componenteTocadoFormulario, 'lateralidade': true })}
                />
            </Fieldset>

            {/*Exemplo de utilização de campo Autocomplete com opções completamente carregadas (sem busca asíncrona no servidor)*/}
            {/*Usar da mesma maneira (presença de options, value e onChange)*/}
            <Fieldset legend="Agente causador do acidente de trabalho" spacing={4}>
                <CustomAutocomplete
                    md={12}
                    options={props.modelo.agenteCausador.fonteDadosAutocomplete}
                    getOptionLabel={(option) => option.rotulo}
                    value={obterOpcaoAutocompletePorValorVep(props.modelo.agenteCausador.fonteDadosAutocomplete, props.modelo.agenteCausador.valor)}
                    onChange={(event, newValue) => {
                        props.setModelo({ ...props.modelo, agenteCausador: { ...props.modelo.agenteCausador, valor: newValue != null ? newValue.valor : '' } });
                    }}
                    readOnly={props.visualizacao}
                    inputProps={{
                        label: 'Agente Causador',
                        title: props.modelo.agenteCausador.descricao,
                        required: true,
                        ...regraValidacaoFormulario['agenteCausador'].obterPropriedadesValidacao(),
                        onBlur: () => setComponenteTocadoFormulario({ ...componenteTocadoFormulario, 'agenteCausador': true })
                    }}
                />
            </Fieldset>

            <Fieldset legend="Atestado Médico" spacing={4}>
                <VepDatePicker
                    accessor="atestadoMedico.dataAtendimento"
                    label="Data do Atendimento"
                    model={props.modelo}
                    setModel={props.setModelo}
                    xs={12} md={3}
                    readOnly={props.visualizacao}
                    {...regraValidacaoFormulario['atestadoMedico.dataAtendimento'].obterPropriedadesValidacao()}
                    onBlur={() => setComponenteTocadoFormulario({ ...componenteTocadoFormulario, 'atestadoMedico.dataAtendimento': true })}
                />

                <VepTimePicker
                    accessor="atestadoMedico.horaAtendimento"
                    label="Hora do Atendimento"
                    model={props.modelo}
                    setModel={props.setModelo}
                    xs={12} md={3}
                    readOnly={props.visualizacao}
                    {...regraValidacaoFormulario['atestadoMedico.horaAtendimento'].obterPropriedadesValidacao()}
                    onBlur={() => setComponenteTocadoFormulario({ ...componenteTocadoFormulario, 'atestadoMedico.horaAtendimento': true })}
                />

                <VepRadioGroup
                    accessor="atestadoMedico.houveInternacao"
                    label="Houve internação?"
                    model={props.modelo}
                    setModel={props.setModelo}
                    xs={12} md={2}
                    readOnly={props.visualizacao}
                    {...regraValidacaoFormulario['atestadoMedico.houveInternacao'].obterPropriedadesValidacao()}
                    onBlur={() => setComponenteTocadoFormulario({ ...componenteTocadoFormulario, 'atestadoMedico.houveInternacao': true })}
                />

                <VepTextField
                    accessor="atestadoMedico.duracaoEstimadaTratamentoEmDias"
                    model={props.modelo}
                    setModel={props.setModelo}
                    xs={12} md={4}
                    readOnly={props.visualizacao}
                    {...regraValidacaoFormulario['atestadoMedico.duracaoEstimadaTratamentoEmDias'].obterPropriedadesValidacao()}
                    onBlur={() => setComponenteTocadoFormulario({ ...componenteTocadoFormulario, 'atestadoMedico.duracaoEstimadaTratamentoEmDias': true })}
                />

                <VepRadioGroup
                    accessor="atestadoMedico.houveAfastamento"
                    label="Houve afastamento durante o tratamento?"
                    model={props.modelo}
                    setModel={props.setModelo}
                    xs={12} md={4}
                    readOnly={props.visualizacao}
                    disabled={props.modelo.houveObito.valor == 'S'}
                    {...regraValidacaoFormulario['atestadoMedico.houveAfastamento'].obterPropriedadesValidacao()}
                    onBlur={() => setComponenteTocadoFormulario({ ...componenteTocadoFormulario, 'atestadoMedico.houveAfastamento': true })}
                />

                <CustomAutocomplete
                    md={8}
                    options={props.modelo.atestadoMedico.naturezaLesao.fonteDadosAutocomplete}
                    getOptionLabel={(option) => option.rotulo}
                    value={obterOpcaoAutocompletePorValorVep(props.modelo.atestadoMedico.naturezaLesao.fonteDadosAutocomplete, props.modelo.atestadoMedico.naturezaLesao.valor)}
                    onChange={(event, newValue) => {
                        props.setModelo({ ...props.modelo, atestadoMedico: { ...props.modelo.atestadoMedico, naturezaLesao: { ...props.modelo.atestadoMedico.naturezaLesao, valor: newValue != null ? newValue.valor : '' } } });
                    }}
                    readOnly={props.visualizacao}
                    inputProps={{
                        label: 'Natureza da Lesão',
                        title: props.modelo.atestadoMedico.naturezaLesao.descricao,
                        required: true,
                        ...regraValidacaoFormulario['atestadoMedico.naturezaLesao'].obterPropriedadesValidacao(),
                        onBlur: () => setComponenteTocadoFormulario({ ...componenteTocadoFormulario, 'atestadoMedico.naturezaLesao': true })
                    }}
                />

                <VepTextField
                    accessor="atestadoMedico.descricaoComplementarLesao"
                    model={props.modelo}
                    setModel={props.setModelo}
                    xs={12} md={12}
                    multiline
                    rows={2}
                    readOnly={props.visualizacao}
                />

                <VepTextField
                    accessor="atestadoMedico.diagnosticoProvavel"
                    model={props.modelo}
                    setModel={props.setModelo}
                    xs={12} md={12}
                    multiline
                    rows={2}
                    readOnly={props.visualizacao}
                />

                {/*Exemplo de utilização de campo Autocomplete com busca assíncrona dos dados no servidor*/}
                {/*Usar da mesma maneira (presença de queryUrl, value e onChange, sendo que, neste último, a fonte de dados do autocomplete também é atualizada)*/}
                <CustomAutocomplete
                    md={12}
                    queryUrl={`util/obterFonteDadosAutocomplete/${props.modelo.atestadoMedico.cid.identificadorFonteDados}/${null}`}
                    queryMinLength={3}
                    getOptionLabel={(option) => option.rotulo}
                    value={obterOpcaoAutocompletePorValorVep(props.modelo.atestadoMedico.cid.fonteDadosAutocomplete, props.modelo.atestadoMedico.cid.valor)}
                    onChange={(event, newValue) => {
                        props.setModelo({ ...props.modelo, atestadoMedico: { ...props.modelo.atestadoMedico, cid: { ...props.modelo.atestadoMedico.cid, valor: !isUndefinedOrNull(newValue) ? newValue.valor : '', fonteDadosAutocomplete: !isUndefinedOrNull(newValue) ? [newValue] : [] } } });
                    }}
                    readOnly={props.visualizacao}
                    inputProps={{
                        label: props.modelo.atestadoMedico.cid.rotulo,
                        title: props.modelo.atestadoMedico.cid.descricao,
                        required: true,
                        ...regraValidacaoFormulario['atestadoMedico.cid'].obterPropriedadesValidacao(),
                        onBlur: () => setComponenteTocadoFormulario({ ...componenteTocadoFormulario, 'atestadoMedico.cid': true })
                    }}
                />

                <VepTextField
                    accessor="atestadoMedico.observacao"
                    model={props.modelo}
                    setModel={props.setModelo}
                    xs={12} md={12}
                    multiline
                    rows={2}
                    readOnly={props.visualizacao}
                />
            </Fieldset>

            <Fieldset legend="Médico ou dentista que emitiu o atestado" spacing={4}>
                <VepTextField
                    accessor="atestadoMedico.nomeEmitente"
                    model={props.modelo}
                    setModel={props.setModelo}
                    xs={12} md={7}
                    readOnly={props.visualizacao}
                    {...regraValidacaoFormulario['atestadoMedico.nomeEmitente'].obterPropriedadesValidacao()}
                    onBlur={() => setComponenteTocadoFormulario({ ...componenteTocadoFormulario, 'atestadoMedico.nomeEmitente': true })}
                />

                <VepSelect
                    accessor="atestadoMedico.orgaoClasse"
                    model={props.modelo}
                    setModel={props.setModelo}
                    xs={12} md={5}
                    readOnly={props.visualizacao}
                    {...regraValidacaoFormulario['atestadoMedico.orgaoClasse'].obterPropriedadesValidacao()}
                    onBlur={() => setComponenteTocadoFormulario({ ...componenteTocadoFormulario, 'atestadoMedico.orgaoClasse': true })}
                />

                <VepTextField
                    accessor="atestadoMedico.numeroInscricaoOrgaoClasse"
                    label="Número do órgão de classe ou  Registro do Ministério da Saúde (RMS)"
                    title={props.modelo.atestadoMedico.numeroInscricaoOrgaoClasse.descricao}
                    model={props.modelo}
                    setModel={props.setModelo}
                    xs={12} md={6}
                    readOnly={props.visualizacao}
                    {...regraValidacaoFormulario['atestadoMedico.numeroInscricaoOrgaoClasse'].obterPropriedadesValidacao()}
                    onBlur={() => setComponenteTocadoFormulario({ ...componenteTocadoFormulario, 'atestadoMedico.numeroInscricaoOrgaoClasse': true })}
                />

                <VepSelect
                    accessor="atestadoMedico.ufOrgaoClasse"
                    model={props.modelo}
                    setModel={props.setModelo}
                    xs={12} md={3}
                    required={props.modelo.atestadoMedico.orgaoClasse.valor == 1 || props.modelo.atestadoMedico.orgaoClasse.valor == 2}
                    emptyOption
                    readOnly={props.visualizacao}
                    {...regraValidacaoFormulario['atestadoMedico.ufOrgaoClasse'].obterPropriedadesValidacao()}
                    onBlur={() => setComponenteTocadoFormulario({ ...componenteTocadoFormulario, 'atestadoMedico.ufOrgaoClasse': true })}
                />
            </Fieldset>
        </Fragment>
    );
}

export default Catv_S_01_01_00Consulta;